<template>



<a-drawer :title="`广告素材报表数据 (${model.show_name})`" :width="1550" :visible="showPromotionPage" :body-style="{ paddingBottom: '1px' }"
@close="close">
              <div class="report-page">
                    <template>

                      <vxe-grid
                        class="table-scrollbar"
                        v-bind="tableGrid"
                        @page-change="handlePageChange"
                        @sort-change="handleSortChange"
                        @checkbox-change="handleRowChange"
                        @checkbox-all="handleRowChange"
                        :checkbox-config="{ checkMethod: checCheckboxkMethod}">
                      >
                    

                      <template #toolbar_buttons>
                        <div class="search-wrapper" style="background:#f8f8f9;padding:0px;margin:0px;height:70px">
                          <div class="title" style="height:10px;line-height:10px"><a-icon type="search" /> 数据筛选</div>
                          <a-space style="margin-top:15px">
                            <a-auto-complete
                              placeholder="媒体主体"
                              :data-source="filteredCorporations"
                              v-model="queryParam.advertiser_name"
                              @change="changeMediaCorporation"
                              allowClear
                            />

                            <byted-range-picker
                            v-model="queryParam.date"
                            format="YYYY-MM-DD"
                            value-format="YYYY-MM-DD"
                            :shortcuts="shortcutsR"
                            editable
                            :transfer="true"
                            :placeholder="['请选择开始日期', '请选择结束日期']"
                          >
                          </byted-range-picker>

                          
                              <a-button type="primary" @click="search">查询</a-button>

                              <a-space style="margin-top:8px" v-if="accessTo('changePromotionMaterialStatus')">
                                <a-dropdown :disabled="selectedRowKeys.length === 0" >
                                    <a-menu slot="overlay">
                                      <a-menu-item key="1" @click="changeAdMaterialStatus(null, 'ENABLE',  true)" v-if="accessTo('changePromotionMaterialStatus')">
                                          <a-icon type="check-square"/>批量启用素材
                                      </a-menu-item>
                                      <a-menu-item key="2" @click="changeAdMaterialStatus(null, 'DISABLE',  true)" v-if="accessTo('changePromotionMaterialStatus')">
                                          <a-icon type="pause-circle"/>批量暂停素材
                                      </a-menu-item>
                                      <a-menu-item key="2" @click="destroyPromotionMaterial()" v-if="accessTo('destroyPromotionMaterial')">
                                          <a-icon type="delete"/>批量删除素材
                                      </a-menu-item>
                                 

                                    </a-menu>
                                    <a-button> 批量操作
                                        <a-icon type="down"/>
                                    </a-button>
                                </a-dropdown>
                              </a-space>


                          </a-space>
                      </div>
                      </template>

                     





              <template #video_cover="{ row }" >
                <div class="cover"  @click="showPreview(row)">
                  <div>
                    <img :src="row.video_cover|defaultCover" alt=""  >
                    <a-icon type="play-circle" class="play-icon" />
                  </div>
                </div>
              </template>

              <template #material="{ row }">
                <div>
                  {{ row.name || '-' }}<br>
                  【{{ row.material_id || '-' }}】<br>
                </div>
              </template>

              <template #advertiser="{ row }">
                {{row.advertiser_name}} <br>
                【{{row.advertiser_id}}】
               
                <a-tag color="orange" v-if="row.app_type === 2">抖小</a-tag>
                <a-tag color="cyan" v-if="row.app_type === 1">微小</a-tag>

                <br />
                <!-- 组织素材（material_source=BP）属于组织资产，不支持推送给其他广告主：展示说明并隐藏推送按钮 -->
                <a-tooltip v-if="row.material_source === 'BP'" title="该素材来自组织（BP），不支持推送给其他广告主">
                  <span style="color:#999;cursor:not-allowed">组织素材不能推送</span>
                </a-tooltip>
                <!-- 素材来源无值时同样不提供推送入口 -->
                <a-button v-else-if="row.material_source" type="primary" size="small" @click="uploadToMedia(row)">
                  素材推送
                </a-button>
              </template>

              <template #promotion="{ row }">
                <div v-if="row.promotion && row.media === 2" style="text-align:left">
                  广告ID：{{row.promotion.promotion_id}}<br>
                  广告名称：{{row.promotion.promotion_name}}<br>
                  广告状态：<a-tag color="green" v-if="row.promotion.opt_status=='ENABLE'">开启</a-tag>
                  <a-tag color="red" v-else>关闭</a-tag>
                </div>
                <div v-else-if="row.promotion && row.media === 1" style="text-align:left">
                  创意ID：{{row.promotion.promotion_id}}<br>
                  创意名称：{{row.promotion.promotion_name}}<br>
                  创意状态：<a-tag :color="row.promotion.status==52?'green':'red'">{{row.promotion.status_reason}}</a-tag><br>
                  投放状态：<a-tag color="green" v-if="row.promotion.opt_status==1">投放</a-tag>
                  <a-tag color="red" v-else>暂停</a-tag>
                </div>
                <div v-else>
                  -
                </div>
              </template>

                      </vxe-grid>
                    </template>
              </div>
              <create-form v-if="showUploadForm" :showUploadForm.sync="showUploadForm" :model="materialModel" />
</a-drawer>
    
</template>

<style lang="less" scoped>
@import 'Promotion';
</style>

<script>
import Promotion from './Promotion'
export default Promotion
</script>
